var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImproveHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.864,
    height: 101.966,
    viewBox: "0 0 133.864 101.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "increase_1_",
    "data-name": "increase (1)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56444",
    "data-name": "Group 56444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87527",
    "data-name": "Path 87527",
    d: "M45.687,132.374a15.687,15.687,0,1,1,15.687-15.687A15.7,15.7,0,0,1,45.687,132.374Z",
    transform: "translate(-22.156 -90.541)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87528",
    "data-name": "Path 87528",
    d: "M255.687,92.374a15.687,15.687,0,1,1,15.687-15.687A15.7,15.7,0,0,1,255.687,92.374Z",
    transform: "translate(-177.252 -61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87529",
    "data-name": "Path 87529",
    d: "M129.942,161H114.255a3.922,3.922,0,1,0,0,7.844h6.219L80.266,209.052l-10.3-10.3a3.922,3.922,0,0,0-5.546,0L34.195,228.978H3.922a3.922,3.922,0,1,0,0,7.844h31.9a3.92,3.92,0,0,0,2.773-1.149l28.6-28.6,10.3,10.3a3.922,3.922,0,0,0,5.546,0L126.02,174.39v6.219a3.922,3.922,0,1,0,7.844,0V164.922A3.922,3.922,0,0,0,129.942,161Z",
    transform: "translate(0 -134.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87530",
    "data-name": "Path 87530",
    d: "M246.531,195.978a23.48,23.48,0,0,1-26,0A23.508,23.508,0,0,0,210,215.593v7.415l3.969-3.969a11.765,11.765,0,0,1,16.638,0l4.753,4.753,19.052-19.052A23.643,23.643,0,0,0,246.531,195.978Z",
    transform: "translate(-155.095 -160.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87531",
    "data-name": "Path 87531",
    d: "M10.53,235.978A23.508,23.508,0,0,0,0,255.593v20.916H30.945l16.116-16.116v-4.8a23.508,23.508,0,0,0-10.53-19.615,23.48,23.48,0,0,1-26,0Z",
    transform: "translate(0 -190.23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImproveHealth);
export default __webpack_public_path__ + "static/media/improveHealth.c98b58e0ea2cb2bc424cafe11c3a23d0.svg";
export { ForwardRef as ReactComponent };